// class ResMsgDTO {

// pgMeTrnRefNo;
// orderId;
// authNStatus;
// authZStatus;
// captureStatus;
// rrn;
// authZCode;
// responseCode;
// trnReqDate;
// statusCode;
// statusDesc;
// addField1;
// addField2;
// addField3;
// addField4;
// addField5;
// addField6;
// addField7;
// addField8;
// addField9;
// addField10;
// pgRefCancelReqId;
// trnAmt;
// refundAmt;


function ResMsgDTO() {}


ResMsgDTO.prototype.getPgMeTrnRefNo = function() {
    return this.pgMeTrnRefNo;
}



ResMsgDTO.prototype.setPgMeTrnRefNo = function(pgMeTrnRefNo) {
    this.pgMeTrnRefNo = pgMeTrnRefNo;
}



ResMsgDTO.prototype.getOrderId = function() {
    return this.orderId;
}



ResMsgDTO.prototype.setOrderId = function(orderId) {
    this.orderId = orderId;
}



ResMsgDTO.prototype.getAuthNStatus = function() {
    return this.authNStatus;
}



ResMsgDTO.prototype.setAuthNStatus = function(authNStatus) {
    this.authNStatus = authNStatus;
}



ResMsgDTO.prototype.getAuthZStatus = function() {
    return this.authZStatus;
}



ResMsgDTO.prototype.setAuthZStatus = function(authZStatus) {
    this.authZStatus = authZStatus;
}



ResMsgDTO.prototype.getCaptureStatus = function() {
    return this.captureStatus;
}



ResMsgDTO.prototype.setCaptureStatus = function(captureStatus) {
    this.captureStatus = captureStatus;
}



ResMsgDTO.prototype.getRrn = function() {
    return this.rrn;
}



ResMsgDTO.prototype.setRrn = function(rrn) {
    this.rrn = rrn;
}



ResMsgDTO.prototype.getAuthZCode = function() {
    return this.authZCode;
}



ResMsgDTO.prototype.setAuthZCode = function(authZCode) {
    this.authZCode = authZCode;
}



ResMsgDTO.prototype.getResponseCode = function() {
    return this.responseCode;
}



ResMsgDTO.prototype.setResponseCode = function(responseCode) {
    this.responseCode = responseCode;
}



ResMsgDTO.prototype.getTrnReqDate = function() {
    return this.trnReqDate;
}



ResMsgDTO.prototype.setTrnReqDate = function(trnReqDate) {
    this.trnReqDate = trnReqDate;
}



ResMsgDTO.prototype.getStatusCode = function() {
    return this.statusCode;
}



ResMsgDTO.prototype.setStatusCode = function(statusCode) {
    this.statusCode = statusCode;
}



ResMsgDTO.prototype.getStatusDesc = function() {
    return this.statusDesc;
}



ResMsgDTO.prototype.setStatusDesc = function(statusDesc) {
    this.statusDesc = statusDesc;
}



ResMsgDTO.prototype.getAddField1 = function() {
    return this.addField1;
}



ResMsgDTO.prototype.setAddField1 = function(addField1) {
    this.addField1 = addField1;
}



ResMsgDTO.prototype.getAddField2 = function() {
    return this.addField2;
}



ResMsgDTO.prototype.setAddField2 = function(addField2) {
    this.addField2 = addField2;
}



ResMsgDTO.prototype.getAddField3 = function() {
    return this.addField3;
}



ResMsgDTO.prototype.setAddField3 = function(addField3) {
    this.addField3 = addField3;
}



ResMsgDTO.prototype.getAddField4 = function() {
    return this.addField4;
}



ResMsgDTO.prototype.setAddField4 = function(addField4) {
    this.addField4 = addField4;
}



ResMsgDTO.prototype.getAddField5 = function() {
    return this.addField5;
}



ResMsgDTO.prototype.setAddField5 = function(addField5) {
    this.addField5 = addField5;
}



ResMsgDTO.prototype.getAddField6 = function() {
    return this.addField6;
}



ResMsgDTO.prototype.setAddField6 = function(addField6) {
    this.addField6 = addField6;
}



ResMsgDTO.prototype.getAddField7 = function() {
    return this.addField7;
}



ResMsgDTO.prototype.setAddField7 = function(addField7) {
    this.addField7 = addField7;
}



ResMsgDTO.prototype.getAddField8 = function() {
    return this.addField8;
}



ResMsgDTO.prototype.setAddField8 = function(addField8) {
    this.addField8 = addField8;
}



ResMsgDTO.prototype.getAddField9 = function() {
    return this.addField9;
}



ResMsgDTO.prototype.setAddField9 = function(addField9) {
    this.addField9 = addField9;
}



ResMsgDTO.prototype.getAddField10 = function() {
    return this.addField10;
}



ResMsgDTO.prototype.setAddField10 = function(addField10) {
    this.addField10 = addField10;
}



ResMsgDTO.prototype.getPgRefCancelReqId = function() {
    return this.pgRefCancelReqId;
}



ResMsgDTO.prototype.setPgRefCancelReqId = function(pgRefCancelReqId) {
    this.pgRefCancelReqId = pgRefCancelReqId;
}



ResMsgDTO.prototype.getTrnAmt = function() {
    return this.trnAmt;
}


ResMsgDTO.prototype.setTrnAmt = function(trnAmt) {
    this.trnAmt = trnAmt;
}


ResMsgDTO.prototype.getRefundAmt = function() {
    return this.refundAmt;
}


ResMsgDTO.prototype.setRefundAmt = function(refundAmt) {
    this.refundAmt = refundAmt;
}
module.exports = ResMsgDTO;
// }